<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() { },
};
</script>

<style>
#app {
  font-size: 12px;
  font-family: Verdana, Geneva, sans-serif;
  /* overflow-y: scroll; */
  -webkit-text-size-adjust: none;
  line-height: 24px;
  color: #666;
  /* background: url(#/body_bg.jpg) top repeat-x #FFF; */
  /* background: url(./assets/images/body_bg.jpg) top repeat-x #fff; */
}

* {
  margin: 0;
  padding: 0;
  font-size: 12px;
  box-sizing: border-box;
}

p {
  color: #ff0000;
  font-weight: 700;
}

p span {
  color: #00ff00;
}

a {
  text-decoration: none;
  color: #666;
}

ul li {
  list-style: none;
}

img {
  border: none;
}

body {
  font-size: 12px !important;
  font-family: Verdana, Geneva, sans-serif;
  overflow-y: scroll;
  -webkit-text-size-adjust: none;
  line-height: 24px;
  background: #FFF;
  color: #666;
}

a {
  text-decoration: none;
  color: #666;
}

a:hover {
  text-decoration: none;
  color: #00389F;
}

.center {
  margin: 0 auto;
}

.pd5 {
  padding: 5px;
}

.pd {
  padding: 10px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.pl10 {
  padding-left: 10px;
}

.pr10 {
  padding-right: 10px;
}

.mt10 {
  margin-top: 10px;
  padding-left: -20px;
  text-indent: 0;
}

.mb10 {
  margin-bottom: 10px;
}

.pd8 {
  padding: 8px;
}

.pd16 {
  padding: 16px;
}

.ppd {
  padding: 15px 0;
}

.pt10 {
  padding-top: 10px;
}

.pt20 {
  padding-top: 20px;
}

.pt30 {
  padding-top: 30px;
}

.pd10 {
  padding: 10px;
}

.pd8 {
  padding: 8px;
}

.mt20 {
  margin-top: 20px;
}

.mt30 {
  margin-top: 30px;
}

.mb30 {
  margin-bottom: 30px;
}

.f00 {
  color: #f00;
}

.textcenter {
  text-align: center;
}

.pointer {
  cursor: pointer;
  display: inline-block;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  font-size: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  zoom: 1;
}

.nav {
  margin-bottom: 2px;
  font-family: "\5fae\8f6f\96c5\9ed1", "\5b8b\4f53", Arial;
}

.nav td {
  text-align: center;
  font-weight: bold;
}

/* .nav td a { display:block; font-size:14px; width:194px; color:#FFF; height:30px; line-height:30px; background:url(images/m1.jpg) center no-repeat;} */
/* .nav td a:hover,.nav td a.curent { color:#FFF; width:194px; height:30px; line-height:30px; background:url(images/m2.jpg) center no-repeat;} */


/* .sinput { background:url(images/s.jpg) no-repeat; width:142px; height:19px; border:none; padding-left:10px; vertical-align:middle; line-height:20px; color:#CCC;} */
.box {
  border: solid 1px #D9D9D9;
}

.tt {
  font-size: 16px;
  color: #898989;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.foot {
  margin-top: 70px;
  border-top: solid 1px #E4E4E4;
  height: 80px;
}



/*修改滚动条样式*/

::-webkit-scrollbar {
  width: 6px;
  height: 10px;
  /**/
}

#equipment-search .ant-input:focus {
  box-shadow: none
}

::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e3e3e3;
}

::-webkit-scrollbar-corner {
  /* background: #179a16; */
}
</style>


// WEBPACK FOOTER //
// src/App.vue